import { render, staticRenderFns } from "./SearchEdit.vue?vue&type=template&id=5873db03"
import script from "./SearchEdit.vue?vue&type=script&lang=js"
export * from "./SearchEdit.vue?vue&type=script&lang=js"
import style0 from "./SearchEdit.vue?vue&type=style&index=0&id=5873db03&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports